import { cn } from "@/lib/utils";

interface BadgeProps {
  children: React.ReactNode;
  variant?: "sale" | "new" | "stock" | "status" | "success" | "warning" | "info" | "error";
  className?: string;
}

const VARIANTS = {
  sale: "bg-[var(--sf-accent)] text-white",
  new: "bg-[var(--sf-secondary)] text-white",
  stock: "bg-red-100 text-red-700",
  status: "bg-gray-100 text-gray-700",
  success: "bg-green-100 text-green-700",
  warning: "bg-yellow-100 text-yellow-700",
  info: "bg-blue-100 text-blue-700",
  error: "bg-red-100 text-red-700",
};

export function Badge({ children, variant = "sale", className }: BadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold",
        VARIANTS[variant],
        className
      )}
    >
      {children}
    </span>
  );
}
